import React from 'react'
import { DialogContainer } from 'react-md'

const Dialog = ({
  title,
  visible,
  onCancel,
  onConfirm,
  children,
  confirmLabel,
  cancelLabel,
  ...rest
}) => (
  <DialogContainer
    title={title}
    visible={visible}
    onHide={onCancel}
    actions={[{
      onClick: onCancel,
      primary: false,
      label: cancelLabel || 'Cancel'
    }, {
      onClick: onConfirm,
      primary: true,
      label: confirmLabel || 'Confirm'
    }]}
    {...rest}
  >
    {children}
  </DialogContainer>
)

export default Dialog



// WEBPACK FOOTER //
// ./src/components/Dialog/index.js